export const isTrue = (value) => value === true || value === 'True';
